import React, { Component } from 'react'
import { connect } from 'react-redux'

import Content from '../../components/Content'
import Container from '../../components/Container'
import List from './List'

import { fetchProjects } from '../../model/projects/actions'

class Projects extends Component {
  componentDidMount = () => {
    this.props.fetchProjects()
  }
  render() {
    const { projects = [] } = this.props
    return (
      <Container>
        <Content />
        <List data={projects} />
      </Container>
    )
  }
}

export default connect(state => state, { fetchProjects })(Projects)
